import { render, staticRenderFns } from "./MovingFromFormStep.vue?vue&type=template&id=fa9ab70e"
import script from "./MovingFromFormStep.vue?vue&type=script&lang=js"
export * from "./MovingFromFormStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports